<template>
  <div class="more-reward-wrappper" @click.stop="gotoMoreBuyMoreReward">
    <div class="banner-content">
      <img :src="moreBuyBanner.image">
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'moreBuyMoreReward',
  props: {
    moreBuyBanner: {
      type: Object,
      default() {
        return {}
      } 
    }
  },
  computed: {
    ...mapGetters(['shopId', 'luckBagCode', 'smsId'])
  },
  mounted() {
    thinkingReport.track('exposure', {
      point_id: '26471',
      page_id: '80586',
      content_id: this.luckBagCode,
      sms_id: this.smsId
    })
  },
  methods: {
    gotoMoreBuyMoreReward() {
      thinkingReport.track('others', {
        point_id: '26472',
        page_id: '80586',
        content_id: this.luckBagCode,
        sms_id: this.smsId
      })
      const { hostname } = window.location
      const y = hostname.split('.')[0]
      const userPath = y === 'spe' ? 'm.yunjiglobal.com' : 't-do-dev.yunjiglobal.com' // 拉起app的现网域名就是m.yunjiglobal.com
      window.location.href = `${window.location.protocol}//${userPath}/yjbuyer/seller-link?shopId=${this.shopId}&goType=callAppSubject&subjectId=${this.moreBuyBanner.specialId}`
    }
  }
}
</script>

<style lang="less" scoped>
.more-reward-wrappper {
  padding-bottom: 2rem;
  width: 100%;
  background-color: #FF444E;
  .banner-content {
    background-color: #FFEEEE;
    margin: 0 0.24rem;
    border-radius: 0.2rem;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
    }
  }
}
</style>
